import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaLayoutVertical from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutVertical';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDDialogActions, FDDialogContent, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';


function DefaultLayout() {
  const { resource, onSubmit, saving } = useMetaLayoutContext();

  return (
    <>
      <MetaControlField attr={'title'} />
      <FDDialogContent>
        <FDStack direction={'column'} justifyContent={'center'} alignItems={'stretch'} spacing={2} test={'dicrs-challenge-totp-layout'}>
          <MetaControlField attr={'primaryText'} />
          <MetaLayoutVertical resource={resource} />
        </FDStack>
      </FDDialogContent>
      <FDDialogActions>
        <FDPrimaryActionButton onClick={onSubmit} loading={saving} test={'dicrs-challenge-default-layout-submit-button'} label={'Submit'} />
      </FDDialogActions>
    </>
  );
}

DefaultLayout.propTypes = {
};

DefaultLayout.defaultProps = {
};

export default DefaultLayout;
